import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function CopySymbol({ symbol }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState('idle');

  useEffect(() => {
    if (status !== 'copied') return undefined;
    const timeout = setTimeout(() => setStatus('idle'), 5000);
    return () => clearTimeout(timeout);
  }, [status]);

  const copy = async (event) => {
    event.stopPropagation();
    if (status === 'copying' || status === 'copied') return;
    setStatus('copying');
    try {
      if (!navigator.clipboard?.writeText) {
        throw new Error('Clipboard API is unavailable');
      }
      await navigator.clipboard.writeText(symbol);
      setStatus('copied');
    } catch (error) {
      console.error('Failed to copy symbol:', error);
      setStatus('error');
    }
  };

  return (
    <span className="inline-flex min-w-0 flex-col items-start">
      <button
        type="button"
        onClick={copy}
        disabled={status === 'copying' || status === 'copied'}
        title={t('copy_symbol', { symbol })}
        aria-label={t('copy_symbol', { symbol })}
        className="inline-flex min-h-7 items-center gap-1 rounded font-semibold hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:opacity-50"
      >
        <span className="break-all">{symbol}</span>
      </button>
      <span
        role="status"
        className={status === 'error' ? 'text-xs font-normal text-red-600'
          : status === 'copied' ? 'text-xs font-normal text-green-600' : 'sr-only'}
      >
        {status === 'copied' ? t('copied') : ''}
        {status === 'error' ? t('symbol_copy_failed') : ''}
      </span>
    </span>
  );
}
